'use strict';
module.exports = function setValueForKeyArray(params) {
	if (!params) {
		throw new Error('invalid-args');
	}

	const {target, keyArray, value} = params,
		validArgs = params && target && keyArray && Array.isArray(keyArray) && keyArray.length && keyArray[0],
		property = validArgs && keyArray[0],
		remainingKeyArray = validArgs && keyArray.slice(1),
		isArrayIndex = validArgs && Array.isArray(target) && Number.isInteger(property);
	if (!validArgs) {
		throw new Error('invalid-args');
	}
	if (!remainingKeyArray.length) {
		if (value === undefined) {
			delete target[property];
		} else {
			target[property] = value;
		}

	} else  {
		if (!isArrayIndex && !Object.prototype.hasOwnProperty.call(target, property)) {
			target[property] = {};
		}
		setValueForKeyArray({target: target[property], keyArray: remainingKeyArray, value});
	}
	return target;
};

